export default "__VITE_ASSET__fvbxAt$o__"